'use strict';

import React, { PropTypes } from 'react';
import _ from 'lodash';

require('styles/Cypher.css');

class CypherComponent extends React.Component {
  static propTypes = {
    click: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.func
    ]).isRequired,
    image: PropTypes.string.isRequired,
    newWindow: PropTypes.bool
  }

  static defaultProps = {
    newWindow: true
  }

  render() {
    return _.isString(this.props.click) ?
      (
        <div className="pure-u-1-6 cypher-component">
          <a href={this.props.click}
            target={this.props.newWindow ? 'blank' : '_self'}>
            <img src={this.props.image} height={50} />
          </a>
        </div>
      ) :
      (
        <button className="pure-u-1-6 cypher-component"
                onClick={this.props.click}>
          <img src={this.props.image} height={50} />
        </button>
      );
  }
}

CypherComponent.displayName = 'CypherComponent';

export default CypherComponent;



// WEBPACK FOOTER //
// ./src/components/CypherComponent.js